export const prefixMobileExternalLink = (url) => {
  if (url.match(/[a-z]+:\/\//)) {
    return `hbext-${url}`;
  }

  return `hbext-https://${url}`;
};
